// 패스픽 랜딩(공개 페이지) 상수.
//
// 이 화면은 로그인 전에도 열리므로 앱 내부 데이터를 전제하지 않는다 —
// 섹션 항목은 API가 아니라 i18n 키 목록으로만 정의한다.

export const PATHPICK_LANDING_PATH = "/pathpick-landing";
export const PATHPICK_MEMBERSHIP_PATH = "/pathpick/membership";
export const PATHPICK_SEARCH_PRODUCTS_PATH = "/pathpick/search-products";

// 무료 체험 시간 — 플로팅 바 문구에 쓴다(시작 가이드의 FREE_TRIAL_HOURS와 같은 값).
export const PATHPICK_LANDING_FREE_TRIAL_HOURS = 48;

export const PATHPICK_LANDING_CANONICAL_ORIGIN = "https://pathrade.com";

// 시안 이미지 — 카드 한 장이 아니라 영역 단위(2장·3장 묶음)로 들어와 있다.
// (히어로 파일명의 오타는 실제 파일명이라 그대로 둔다.)
export const PATHPICK_LANDING_IMAGES = {
  hero: {
    src: "/images/pathpcik-landing-hero.webp",
    width: 431,
    height: 462,
  },
  hotDeal: {
    src: "/images/pathpick-landing-hotdeal.webp",
    width: 684,
    height: 456,
  },
  normal: {
    src: "/images/pathpick-landing-normal.webp",
    width: 684,
    height: 458,
  },
} as const;

// 섹션 항목 순서 — i18n 키의 하위 키와 1:1로 맞춘다.
export const PROBLEM_ITEM_KEYS = [
  "category",
  "margin",
  "channel",
  "delivery",
] as const;

export const SOLUTION_ITEM_KEYS = [
  "search",
  "select",
  "upload",
  "api",
] as const;

export const COMPARISON_ROW_KEYS = [
  "search",
  "margin",
  "channel",
  "stock",
  "order",
] as const;

export const FAQ_ITEM_KEYS = [
  "target",
  "upload",
  "api",
  "product_info",
  "plan_api",
] as const;

// 시안 팔레트 — 랜딩은 앱 GNB 밖이라 Chakra 테마 토큰 대신 시안 색을 직접 쓴다.
export const PATHPICK_LANDING_COLORS = {
  textStrong: "#1D1D1B",
  textBody: "#4A4A48",
  textMuted: "#6F6F6C",
  textFaint: "#8F8F8C",
  border: "#E4E4E1",
  divider: "#EFEFED",
  surface: "#FFFFFF",
  surfaceMuted: "#F7F8FA",
  placeholder: "#EDEEF0",
  blue: "#1272EF",
  blueHover: "#0F62CC",
  blueActive: "#0D53AC",
  blueDeep: "#25489A",
  green: "#118A5A",
  amber: "#C9791B",
  red: "#C9424B",
} as const;
